import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const MessagePreviewModal = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Message Preview</DialogTitle>
      <DialogContent>
        <Typography
          component="pre"
          style={{ 
            whiteSpace: "pre-wrap", 
            fontFamily: "inherit",
            fontSize: "inherit" 
          }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessagePreviewModal;
